export const tagetedProductPageUrls = ['/products/crm/conversations', '/products/crm/chatbot-builder', '/crm/am_chatbot', '/products/crm/live-chat', '/crm/am_live-chat'];
export const CMS_HUB_URL = '/products/cms';
export const SALES_URL = '/products/sales';
export const FRENCH_DOMAIN_PATTERN = /www\.hubspot\.fr$/;